// Bulk Discount Matrix — quantity thresholds in units, percent off the line total.
// Owner rule: one site-wide structure for eligible regular products (apparel & drinkware).
// Packages/bundles and tier-priced products are excluded — no stacking.
// Percentages are internal only — customers see strikethrough savings, never % badges.
export const DISCOUNT_RULES = {
  "custom-apparel": [
    [6, 3.5],
    [25, 7],
    [50, 15],
    [100, 20],
  ],
  "custom-drinkware": [
    [6, 3.5],
    [25, 7],
    [50, 15],
    [100, 20],
  ],
};

export const bulkPercent = (categorySlug, units) => {
  const rule = DISCOUNT_RULES[categorySlug];
  if (!rule) return 0;
  let pct = 0;
  for (const [min, p] of rule) {
    if (units >= min) pct = p;
  }
  return pct;
};

export const nextTierHint = (categorySlug, units) => {
  const rule = DISCOUNT_RULES[categorySlug];
  if (!rule) return null;
  const next = rule.find(([min]) => units < min);
  if (!next) return null;
  return `Add ${next[0] - units} more to unlock deeper bulk savings`;
};
